export const storeOnlyThumbnail = {
  computed: {
    storeOnlyProductNos () {
      return new Set(this.productList
        .filter(item => this.isStoreOnlyProduct(item))
        .map(item => item.pdNo))
    }
  },
  methods: {
    isStoreOnlyProduct (item) {
      return item?.OFFL_PD_YN === 'Y' || item?.offlPdYn === 'Y' || item?.storeOnlyYn === 'Y'
    },
    isStoreOnlyThumbnail (pdNo) {
      return this.storeOnlyProductNos.has(pdNo)
    }
  }
}
